import { Button, message, Modal, Space, Typography } from 'antd';
import React, { useState } from 'react';

const { Paragraph } = Typography;
const DisableEnableTagModal = ({ onDisableEnableTag, loading, disabled }) => {
  const [isModalDisableVisible, setIsModalDisableVisible] = useState(false);
  const [isModalEnableVisible, setIsModalEnableVisible] = useState(false);

  const handleEnableDisableTag = async (toArchive) => {
    try {
      await onDisableEnableTag(toArchive);
      message.success(toArchive ? 'Tag Archived Successfully' : 'Tag Unarchived Successfully');
    } catch (error) {
      message.error(toArchive ? 'Error Archiving Tag' : 'Error Unarchiving Tag');
    }
    if (toArchive) {
      setIsModalDisableVisible(false);
    } else {
      setIsModalEnableVisible(false);
    }
  };

  return (
    <React.Fragment>
      <Modal
        title="ARCHIVE TAG"
        visible={isModalDisableVisible}
        onCancel={() => setIsModalDisableVisible(false)}
        footer={
          <Space>
            <Button
              type="primary"
              onClick={() => {
                handleEnableDisableTag(true);
              }}
            >
              Archive
            </Button>
            <Button type="default" onClick={() => setIsModalDisableVisible(false)}>
              Cancel
            </Button>
          </Space>
        }
      >
        <Paragraph>Archiving a tag will hide it from your tag options.</Paragraph>
      </Modal>
      <Modal
        title="UNARCHIVE TAG"
        visible={isModalEnableVisible}
        onCancel={() => setIsModalEnableVisible(false)}
        footer={
          <Space>
            <Button
              type="default"
              onClick={() => {
                handleEnableDisableTag(false);
              }}
            >
              Unarchive
            </Button>
            <Button type="default" onClick={() => setIsModalEnableVisible(false)}>
              Cancel
            </Button>
          </Space>
        }
      >
        <Paragraph>Unarchiving a tag will make it available for selection again.</Paragraph>
      </Modal>
      <Button
        shape="round"
        type="default"
        loading={loading}
        hidden={!disabled}
        onClick={() => setIsModalEnableVisible(true)}
      >
        Unarchive Tag
      </Button>
      <Button
        shape="round"
        type="primary"
        hidden={disabled}
        loading={loading}
        onClick={() => setIsModalDisableVisible(true)}
      >
        Archive Tag
      </Button>
    </React.Fragment>
  );
};

export default DisableEnableTagModal;
